import { createSelector } from '@reduxjs/toolkit'
import type { State } from '../../../../../Flux/Slice/index.ts'

export const selectSelectedBucketsBySource = createSelector(
  [(s: typeof State) => s.visualization.sources],
  (sources) => {
    const out: Record<string, { key: string; label: string }[]> = {}
    for (const [sourceId, src] of Object.entries(sources)) {
      out[sourceId] = src?.snapshot?.selectedBuckets ?? []
    }
    return out
  }
)